import styled from 'styled-components'
import { Box, Flex, Svg } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'

export const HealthMeterBox = styled(Box)`
  position: relative;
`

export const HealthStatsFlex = styled(Flex)`
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.sm} {
    top: 50%;
  }
`

export const Gift = styled(PixelatedImage)`
  position: absolute;
  right: 6.5%;
  bottom: 6%;
  width: 8.065%;
  height: 18%;
`

// for MeterBarSvg:
export const FullWidthSvg = styled(Svg)`
  width: 100%;
  height: auto;
`
export const HealthValueCircle = styled.circle<{ health?: number }>`
  transition: transform 0.5s;
  transform: rotate(${({ health }) => (health / 100) * 180 + 180}deg);
  transform-origin: center bottom;
`
